import TrackedModel from "./trackedModel";
import Documentable from "../../mixins/documentable";

export default class BuilderModel extends Documentable(TrackedModel){
  rootModel: BuilderModel;
}
